import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const SocialIcon = ({ href, title, brandColor, hoverGradient, children }) => {
    const [hover, setHover] = useState(false);

    const baseStyle = {
        width: '38px',
        height: '38px',
        borderRadius: '50%',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: hover 
            ? (hoverGradient || brandColor) 
            : 'rgba(255, 255, 255, 0.08)',
        border: hover 
            ? `1px solid ${brandColor || 'transparent'}` 
            : '1px solid rgba(255, 255, 255, 0.14)',
        color: hover ? '#ffffff' : '#cbd5e1',
        textDecoration: 'none',
        transition: 'all 0.25s ease',
        boxShadow: hover 
            ? `0 4px 14px ${brandColor ? brandColor + '55' : 'rgba(0,0,0,0.3)'}` 
            : 'none',
        transform: hover ? 'translateY(-2px)' : 'none',
    };

    return (
        <a 
            href={href} 
            target="_blank" 
            rel="noopener noreferrer" 
            title={title}
            aria-label={title}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            style={baseStyle}
        >
            {children}
        </a>
    );
};

const Footer = () => {
    return (
        <footer style={styles.footer}>
            <div style={styles.container}>
                <div style={styles.grid}>

                    {/* Column 1: Organization & Identity */}
                    <div style={styles.col}>
                        <h4 style={styles.heading}>ARIVU NEST R&D</h4>
                        <p style={styles.orgDesc}>
                            <strong>Arivu Nest – Research and Development</strong> is an apex multidisciplinary research and academic council patronized by <strong>Jjegan Graphers</strong>.
                        </p>
                        <div style={styles.msmeTag}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                                <img src="/images/logos/msme-logo.png" alt="MSME Govt of India" style={{ height: '24px', width: 'auto' }} />
                                <span>Ministry of MSME, Govt. of India</span>
                            </div>
                            <span style={styles.udyamNo}>Udyam: UDYAM-TN-32-0048110</span>
                        </div>
                        <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginTop: '14px' }}>
                            <img src="/images/logos/jjegan-logo.png" alt="Jjegan Graphers" style={{ height: '36px', width: 'auto', background: '#fff', padding: '3px', borderRadius: '6px' }} />
                            <img src="/images/logos/kani-rathnam-logo.png" alt="Kani Rathnam Equality Foundation" style={{ height: '36px', width: 'auto', background: '#fff', padding: '3px', borderRadius: '6px' }} />
                        </div>
                    </div>

                    {/* Column 2: Research & Academic Wings */}
                    <div style={styles.col}>
                        <h4 style={styles.heading}>Research & Projects</h4>
                        <Link to="/research" style={styles.link}>Research & Publications</Link>
                        <Link to="/internships" style={styles.link}>Student Internships & Projects</Link>
                        <Link to="/courses" style={styles.link}>Communication & AI Labs</Link>
                        <Link to="/methodology" style={styles.link}>"Confidence-First" Methodology</Link>
                    </div>

                    {/* Column 3: Institutional Leadership */}
                    <div style={styles.col}>
                        <h4 style={styles.heading}>Institution</h4>
                        <Link to="/about" style={styles.link}>About Arivu Nest R&D</Link>
                        <Link to="/faculty" style={styles.link}>Leadership & Mentors</Link>
                        <Link to="/pricing" style={styles.link}>Memberships &amp; MoUs</Link>
                        <Link to="/verify" style={styles.link}>Verify Certificate / Member Lookup</Link>
                        <Link to="/contact" style={styles.link}>Contact & Centers</Link>
                    </div>

                    {/* Column 4: Official Inquiries & MNC Social Logos */}
                    <div style={styles.col}>
                        <h4 style={styles.heading}>Official Inquiries</h4>
                        <p style={styles.contactItem}>
                            <strong>Executive:</strong> <a href="https://mail.google.com/mail/?view=cm&fs=1&to=dr.sabitha@arivunest.com" target="_blank" rel="noopener noreferrer" style={styles.link}>dr.sabitha@arivunest.com</a>
                        </p>
                        <p style={styles.contactItem}>
                            <strong>Operations &amp; Support:</strong> <a href="https://mail.google.com/mail/?view=cm&fs=1&to=nandhakumar@arivunest.com" target="_blank" rel="noopener noreferrer" style={styles.link}>nandhakumar@arivunest.com</a>
                        </p>
                        <p style={{ ...styles.contactItem, fontSize: '12px', color: '#9ca3af', marginTop: '4px' }}>
                            📍 64, Dhanoosh Kodiyapuram, Kovilpatti &bull; Virudhunagar, TN
                        </p>

                        {/* MNC Minimalist Circular Social Badges */}
                        <div style={{ marginTop: '16px' }}>
                            <span style={{ fontSize: '11px', fontWeight: '700', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.8px', display: 'block', marginBottom: '10px' }}>
                                Connect With Us
                            </span>
                            <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
                                {/* WhatsApp */}
                                <SocialIcon 
                                    href="https://chat.whatsapp.com/E79PDHbC0n286T9ChYsgXo" 
                                    title="Official WhatsApp Community" 
                                    brandColor="#25D366"
                                >
                                    <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                                        <path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.816 9.816 0 0 0 12.04 2m.01 1.67c4.54 0 8.24 3.7 8.24 8.24 0 2.2-.86 4.28-2.42 5.84a8.18 8.18 0 0 1-5.82 2.41c-1.42 0-2.82-.37-4.06-1.08l-.29-.17-3.02.79.81-2.94-.19-.3a8.18 8.18 0 0 1-1.25-4.29c0-4.54 3.7-8.24 8.24-8.24m4.54 11.66c-.25-.13-1.47-.72-1.7-.81-.23-.08-.39-.13-.56.13-.17.25-.64.81-.79.97-.14.17-.29.19-.54.06-.25-.13-1.06-.39-2.02-1.25-.75-.67-1.26-1.49-1.4-1.74-.15-.25-.02-.39.11-.51.11-.11.25-.29.37-.43.13-.15.17-.25.25-.42.08-.17.04-.32-.02-.45s-.56-1.35-.77-1.85c-.2-.49-.41-.42-.56-.43h-.48c-.16 0-.43.06-.66.31-.23.25-.87.85-.87 2.08 0 1.22.89 2.41 1.02 2.58.12.17 1.76 2.68 4.25 3.76.59.26 1.06.41 1.42.53.6.19 1.14.16 1.57.1.48-.07 1.47-.6 1.68-1.18.21-.58.21-1.07.15-1.18-.06-.1-.22-.17-.47-.29"/>
                                    </svg>
                                </SocialIcon>

                                {/* Instagram */}
                                <SocialIcon 
                                    href="https://www.instagram.com/arivunest_official/" 
                                    title="Official Instagram (@arivunest_official)" 
                                    brandColor="#E1306C"
                                    hoverGradient="linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)"
                                >
                                    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                                        <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                                        <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                                    </svg>
                                </SocialIcon>

                                {/* YouTube */}
                                <SocialIcon 
                                    href="https://www.youtube.com/@arivunestofficial" 
                                    title="Official YouTube Channel (@arivunestofficial)" 
                                    brandColor="#FF0000"
                                >
                                    <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                                        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.5 12 3.5 12 3.5s-7.505 0-9.377.55a3.016 3.016 0 0 0-2.122 2.136C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.55 9.376.55 9.376.55s7.505 0 9.377-.55a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                                    </svg>
                                </SocialIcon>

                                {/* LinkedIn */}
                                <SocialIcon 
                                    href="https://www.linkedin.com/in/arivunestofficial/" 
                                    title="Official LinkedIn Network" 
                                    brandColor="#0077b5"
                                >
                                    <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                                        <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.28 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.75M6.46 10.9v8.37H9.2V10.9H6.46M7.83 6.64a1.64 1.64 0 1 0 1.63 1.64 1.64 1.64 0 0 0-1.63-1.64Z"/>
                                    </svg>
                                </SocialIcon>
                            </div>
                        </div>
                    </div>

                </div>

                {/* MNC Clean Non-Overlapping Bottom Bar */}
                <div style={styles.bottomContainer}>
                    <div style={styles.bottomRow}>
                        <div style={styles.brandAndCopy}>
                            <img 
                                src="/images/logos/arivu-nest-logo.png" 
                                alt="Arivu Nest R&D" 
                                style={{ width: '38px', height: '38px', objectFit: 'contain', flexShrink: 0 }} 
                            />
                            <div style={styles.copyBlock}>
                                <p style={styles.copyright}>
                                    &copy; {new Date().getFullYear()} <strong>Arivu Nest – Research and Development</strong> &bull; A Unit / Initiative of <strong>Jjegan Graphers</strong>. All rights reserved.
                                </p>
                                <p style={styles.partnerText}>
                                    Associated with <strong>Kani Rathnam Equality Foundation</strong> &bull; Technology partner <a href="https://premaailabs.tech/" target="_blank" rel="noreferrer" style={styles.partnerLink}>Prema AI Labs</a>
                                </p>
                            </div>
                        </div>

                        <div style={styles.legalLinks}>
                            <Link to="/privacy" style={styles.subLink}>Privacy Policy</Link>
                            <span style={styles.subDot}>&bull;</span>
                            <Link to="/terms" style={styles.subLink}>Terms of Service</Link>
                            <span style={styles.subDot}>&bull;</span>
                            <Link to="/refund-policy" style={styles.subLink}>Refund Policy</Link>
                        </div>
                    </div>
                </div>

            </div>
        </footer>
    );
};

const styles = {
    footer: {
        backgroundColor: '#1e293b',
        color: '#ffffff',
        padding: '65px 0 28px 0',
        marginTop: 'auto',
        borderTop: '3px solid #10b981',
    },
    container: {
        width: '100%',
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 24px',
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(230px, 1fr))',
        gap: '36px',
        marginBottom: '40px',
    },
    col: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
    },
    heading: {
        fontSize: '13.5px',
        fontWeight: '800',
        color: '#10b981',
        marginBottom: '10px',
        textTransform: 'uppercase',
        letterSpacing: '0.8px',
    },
    orgDesc: {
        fontSize: '13px',
        lineHeight: '1.6',
        color: '#cbd5e1',
        margin: '0 0 10px 0',
    },
    msmeTag: {
        background: 'rgba(16, 185, 129, 0.1)',
        border: '1px solid rgba(16, 185, 129, 0.3)',
        padding: '8px 12px',
        borderRadius: '8px',
        fontSize: '12px',
        color: '#34d399',
        display: 'flex',
        flexDirection: 'column',
        gap: '2px',
    },
    udyamNo: {
        fontSize: '11px',
        fontFamily: 'monospace',
        color: '#a7f3d0',
        fontWeight: '700',
    },
    link: {
        color: '#cbd5e1',
        textDecoration: 'none',
        fontSize: '13.5px',
        transition: 'color 0.2s',
    },
    contactItem: {
        fontSize: '13px',
        color: '#cbd5e1',
        margin: '2px 0',
        lineHeight: '1.4',
    },
    bottomContainer: {
        borderTop: '1px solid rgba(255, 255, 255, 0.12)',
        paddingTop: '20px',
    },
    bottomRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '16px',
    },
    brandAndCopy: {
        display: 'flex',
        alignItems: 'center',
        gap: '14px',
        minWidth: 0,
        flex: '1 1 520px',
    },
    copyBlock: {
        display: 'flex',
        flexDirection: 'column',
        gap: '3px',
    },
    copyright: {
        color: '#94a3b8',
        fontSize: '12px',
        margin: 0,
        lineHeight: 1.5,
    },
    partnerText: {
        margin: 0,
        color: '#64748b',
        fontSize: '11px',
        lineHeight: 1.5,
    },
    partnerLink: {
        color: '#34d399',
        textDecoration: 'none',
        fontWeight: '600',
    },
    legalLinks: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        fontSize: '12px',
        flexShrink: 0,
    },
    subLink: {
        color: '#94a3b8',
        textDecoration: 'none',
        transition: 'color 0.2s',
    },
    subDot: {
        color: '#475569',
    },
};

export default Footer;
